module.exports = __webpack_public_path__ + "img/mech-poster_cn.29033a2.jpg";